import { Modals } from '../dependencies';

import TagListItem from '../components/TagListItem';

const { withModal } = Modals.HOC;

export default withModal()(TagListItem);
